import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";
import "./ContributionList.scss";
import SubscriptionSummary from "./SubscriptionSummary";
import { getPaginatedSubscriptions } from "../../Reducers/actions/paymentActions";
import { SubscriptionSummaryRowSkeleton } from "../../components/Skeletons/FinanceListSkeletons";

function ContributionList() {
    const dispatch = useDispatch()

    const {
        auth_user_id,
        subscriptions,
        subscriptionsLoading

    } = useSelector((state) => ({
        auth_user_id: state.auth?.user?.user_id,
        subscriptions: state?.payments?.subscriptions,
        subscriptionsLoading: state?.payments?.subscriptionsLoading,
    }));
    useEffect(() => {
        dispatch(setTopNavbar({ showBackArrow: true, title: "All contributions" }));
        if (!auth_user_id) return;
        dispatch(getPaginatedSubscriptions(0, 10, auth_user_id));
    }, []);

    if (subscriptionsLoading) {
        return (
            <div className="main-container-contribution px-16" role="status" aria-label="Loading contributions">
                {[1, 2, 3, 4, 5].map((i) => (
                    <SubscriptionSummaryRowSkeleton key={i} />
                ))}
            </div>
        );
    }

    return (
        <div className="main-container-contribution px-16">
            {subscriptions?.length === 0 && (
                <div className="empty-subscriptions py-32">You have no subscriptions</div>
            )}
            {subscriptions?.map((subscription) => (
                <SubscriptionSummary
                    subscription={subscription}
                />
            ))}
        </div>
    )
}

export default ContributionList;